import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, DownloadIcon, InfinityIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PRICE } from '../data/content';
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}, {
  icon: InfinityIcon,
  label: 'Acceso para siempre'
}];
export function Hero() {
  return <header className="relative isolate overflow-hidden bg-void-950" data-id="element-104" data-mp="129qudld1bpnv">
      <img src="https://cdn.magicpatterns.com/uploads/4UTN9roSJtn2EekvHrqQ5Z/tapa.png" alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full scale-110 object-cover opacity-30 blur-sm" data-id="element-105" data-mp="xae7x1q2sklt" />
      <div className="pointer-events-none absolute inset-0 bg-void-950/80" aria-hidden="true" data-id="element-106" data-mp="nbonp2apio2e" />
      <div className="neon-grid pointer-events-none absolute inset-0 opacity-70" aria-hidden="true" data-id="element-107" data-mp="3czfk1vt6u14g" />
      <div className="pointer-events-none absolute left-1/2 top-0 h-[34rem] w-[34rem] -translate-x-1/2 -translate-y-1/3 rounded-full bg-gold-500/10 blur-3xl" aria-hidden="true" data-id="element-108" data-mp="3j8iv8twpu6s2" />
      <div className="grain pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" data-id="element-109" data-mp="39albailw2w59" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-14 px-6 py-24 md:py-32 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20" data-id="element-110" data-mp="3e8mud3jbevgq">
        <div data-id="element-111" data-mp="30ggg5mzq2yjx">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8
        }} className="neon-text-soft mb-8 text-[11px] uppercase tracking-label text-gold-500" data-id="element-112" data-mp="30fy7trzsctvn">
            eBook digital · Despertar de conciencia
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="font-display text-4xl font-light leading-[1.08] text-bone-50 sm:text-5xl lg:text-6xl" data-id="element-113" data-mp="2hj5e5umphr0s">
            ¿Y si todo lo que crees real…{' '}
            <em className="neon-text not-italic text-gold-400" data-id="element-114" data-mp="n9qid8z0cs7f">fuera parte del juego?</em>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.25,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-7 max-w-xl text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-115" data-mp="ichwaxaqo40w">
            Un eBook para quienes sienten que la vida es más que lo visible. Una guía de
            reflexión para despertar tu conciencia, cuestionar la Matrix y reconectar con tu
            poder interior.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.35,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-6 max-w-xl border-l border-gold-500/40 pl-5 font-display text-lg italic leading-relaxed text-bone-100" data-id="element-116" data-mp="x3h0lw4jk6eo">
            Si llegaste hasta aquí, no fue por casualidad. Algo en ti ya empezó a despertar.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.45,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-117" data-mp="268y69llgo553">
            <CTAButton label="Quiero despertar ahora" data-id="element-118" data-mp="2ky40ev5fz564" />
            <span className="text-sm text-bone-500" data-id="element-119" data-mp="2l0qc96zd86u5">{PRICE} · Acceso inmediato</span>
          </motion.div>

          <motion.ul initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.9,
          delay: 0.6
        }} className="mt-10 flex flex-wrap gap-x-7 gap-y-3" data-id="element-120" data-mp="2tzley937aysp">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-xs text-bone-500" data-id="element-121" data-mp="znn6wagmo8ye">
                <Icon className="h-3.5 w-3.5 text-gold-500 drop-shadow-[0_0_8px_rgba(34,227,127,0.7)]" aria-hidden="true" data-id="element-122" data-mp="49jd24ununm4" />
                {label}
              </li>)}
          </motion.ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto w-full max-w-sm" data-id="element-123" data-mp="9bifnciktgi0">
          <motion.div className="absolute -inset-10 rounded-full bg-gold-500/20 blur-3xl" aria-hidden="true" animate={{
          opacity: [0.55, 0.9, 0.55]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-124" data-mp="3rg3jtnaxqq46" />
          <motion.img src="https://cdn.magicpatterns.com/uploads/4UTN9roSJtn2EekvHrqQ5Z/tapa.png" alt="Portada del eBook ¿Estás listo para jugar?" className="relative w-full rounded-sm shadow-neon-lg ring-1 ring-gold-500/30" animate={{
          y: [0, -12, 0]
        }} transition={{
          duration: 7,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-125" data-mp="2yxy5vzk539ps" />
        </motion.div>
      </div>
    </header>;
}